import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import localeData from 'dayjs/plugin/localeData';
import isBetween from 'dayjs/plugin/isBetween';
import weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/it';

// Estendi dayjs con i plugin necessari
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(localeData);
dayjs.extend(isBetween);
dayjs.extend(weekday);
dayjs.locale('it');

// Imposta la timezone di default
dayjs.tz.setDefault('Europe/Rome');

export default dayjs;
